import React from "react";
import { useGlobalContext } from "../../../../../../context/global/state";
import { useHistory } from "react-router-dom";
import { Link } from "react-router-dom";
import DropdownDesktop from "../elements/myAccounts/dropdown";
import PlanningAndGuidanceDropdown from "../elements/planningAndGuidance/dropdown";
import NoDemoLink from "../../../../../../components/controllers/shared/tooltip/noDemoLink";

const Left: React.FC = () => {
	const history = useHistory();
	const { data, nav, state } = useGlobalContext();
	const siteContext = nav.getSiteContext(history);

	if (!data[siteContext]) return null;
	const primaryNavItems = data[siteContext].primaryNavItems;

	return (
		<>
			<li>
				<Link
					to={state.pageContext.pathname}
					className="logoWhite"
					tabIndex={0}
					onClick={() => {
						if (history.location.pathname === `/${siteContext}`)
							history.go(0);
					}}
					replace
				></Link>
			</li>
			{primaryNavItems.map((item, index) => {
				const isDropdown = item.dropdown === true;
				const accountsDropdown = <DropdownDesktop />;
				const planningAndGuidanceDropdown = (
					<PlanningAndGuidanceDropdown />
				);
				const isTooltip = item.url === "#no-demo" && !item.dropdown;
				const isLink = !isTooltip && !item.dropdown;
				const isReactLink = item.url.includes("react");
				const reactUrl = item.url.replace("./react/index.html#/", "/");
				const hashPathname = reactUrl.split("#")[1];

				const reactLink = <Link to={reactUrl}>{item.linkText}</Link>;
				const dustLink = <a href={`..${item.url}`}>{item.linkText}</a>;
				const link = isReactLink ? reactLink : dustLink;
				return (
					<>
						{history.location.pathname === hashPathname ? (
							<li
								className="hidden-xs hidden-sm hidden-md primaryNavOnItems myAccounts navItemActive"
								key={`my-accounts-${index}`}
							>
								{isLink && link}
							</li>
						) : (
							<>
								<li
									className="hidden-xs hidden-sm hidden-md primaryNavOnItems myAccounts"
									key={`my-accounts-${index}`}
								>
									{isDropdown && item.id === "myAccounts"
										? accountsDropdown
										: null}
									{isDropdown &&
									item.id === "planningAndGuidance"
										? planningAndGuidanceDropdown
										: null}
									{isTooltip ? (
										<NoDemoLink placement="bottom">
											<button className="btn btn-link btn-link-menu">
												{item.linkText}
											</button>
										</NoDemoLink>
									) : null}
									{isLink && link}
								</li>
							</>
						)}
					</>
				);
			})}
		</>
	);
};

export default Left;
